
import { Component, Vue } from 'vue-property-decorator'
import { AppBox, AppEditableHeader, AppSwitchForm } from '@/components'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import DetailBasicForm from '@/components/DetailBasicForm.vue'
import DetailApple from '@/components/DetailApple.vue'
import DetailAndroid from '@/components/DetailAndroid.vue'
import { appAccountEntity, appEntity, appInfoEntity } from '@/models/models'
import CommonAppItemPlatform from '@/components/CommonAppItemPlatform.vue'
import CommonAppWarning from '@/components/CommonAppWarning.vue'
import DetailSidebar from '@/components/DetailSidebar.vue'
import CommonRenewAppleMembership from '@/components/CommonRenewAppleMembership.vue'
import { androidErrors, iOSErrors } from '@/utils/appUpdateErrorType'
import {
    BUILDING,
    WAITING_FOR_REVIEW,
    IN_REVIEW,
    READY_FOR_SALE,
    ERROR,
    UNKNOWN,
    WAITING_AUTH,
    MISSING_ITC_TEAM_ID,
    DELETE_DEV_CERTIFICATES,
    MISSING_DEVICE,
    WRONG_CREDENTIALS,
    NAME_DUPLICATED,
    DD_ACCOUNT,
    SHARED_ACCOUNT,
} from '@/utils/statusApp'
@Component({
    components: {
        AppBox,
        AppEditableHeader,
        AppSwitchForm,
        DetailAndroid,
        DetailApple,
        DetailBasicForm,
        DetailSidebar,
        CommonAppItemPlatform,
        CommonAppWarning,
        CommonRenewAppleMembership,
        FontAwesomeIcon,
    },
})
export default class Detail extends Vue {
    public app: AppEntity = appEntity
    private openAndroid: boolean = false
    private openIOS: boolean = false

    get updateNeededStatus(): string[] {
        return [
            READY_FOR_SALE,
            BUILDING,
            ERROR,
            UNKNOWN,
            MISSING_ITC_TEAM_ID,
            SHARED_ACCOUNT,
            DD_ACCOUNT,
            NAME_DUPLICATED,
            WRONG_CREDENTIALS,
            MISSING_DEVICE,
            DELETE_DEV_CERTIFICATES,
            WAITING_AUTH,
            IN_REVIEW,
            WAITING_FOR_REVIEW,
        ]
    }

    get isLoading(): boolean {
        return this.$store.state.detail.isLoading
    }

    get appleMembership() {
        return this.app.iOS && this.app.iOS.appleMembership
    }

    get hasDevPermissions(): boolean {
        return this.app.android!.updates.length > 0
            && (this.app.account?.androidType?.length ?? 0) > 0
            && (this.app.account?.apiKey?.length ?? 0) > 0
    }

    get hasErrors() {
        const errors = Object.keys(this.app.errors)
        return {
            android: errors.some((error) => androidErrors.includes(error)),
            ios: errors.some((error) => iOSErrors.includes(error)),
        }
    }

    public shouldUpdate(app?: AppInfoEntity): AppInfoEntity | undefined {
        if (app && app.updates.length > 0) {
            const update = app.updates[app.updates.length - 1]
            const shouldUpdate = this.updateNeededStatus.includes(update.status)
            app.request = shouldUpdate
        }
        return app
    }

    public async mounted() {
        window.scrollTo(0, 0)

        const requestedApp = await this.$store.dispatch(
            'detail/getApp',
            this.$route.params.id,
        )
        this.app = { ...this.app, ...requestedApp }
        this.app.android = { ...appInfoEntity, ...requestedApp.android }
        this.app.iOS = { ...appInfoEntity, ...requestedApp.iOS }
        this.app.brand = { ...appInfoEntity, ...requestedApp.brand }
        this.app.account = { ...appAccountEntity, ...requestedApp.account }

        this.app.account!.hasDevPermissions = this.hasDevPermissions

        if (this.$route.params.platform === 'ios') {
            this.app.iOS!.request = true
        } else if (this.$route.params.platform === 'android') {
            this.app.android!.request = true
        }
    }

    public onClose() {
        if (document.referrer.indexOf(window.location.host) !== -1) {
            this.$router.back()
        } else {
            this.$router.push('/')
        }
    }

    public async onSave() {
        const response = await this.$store.dispatch('detail/saveApp', this.app)

        if (response == null) {
            alert(
                'Erro ao requisitar update de app. Por favor, tente novamente ou entre em contato com um de nossos desenvolvedores',
            )
            return
        }

        this.app = response
        const errors = this.app.errors

        if (errors != null && Object.keys(errors).length > 0) {
            let errorList = ''
            for (const key in errors) {
                if (key.length) {
                    errorList += `\n- ${errors[key]}`
                }
            }
            alert(`Por favor, corrija os erros:\n${errorList}`)

            if (this.hasErrors.android) {
                this.openAndroid = true
            }

            if (this.hasErrors.ios) {
                this.openIOS = true
            }

            if (errors.store != null && !errors.store.isEmpty()) {
                this.$scrollTo('#error', 500, { offset: -100 })
            }
            return
        }

        if (this.$store.getters.canUpdateApps) {
            this.app.android = this.shouldUpdate(this.app.android)
            this.app.iOS = this.shouldUpdate(this.app.iOS)

            if ((this.app.iOS?.request ?? false) || (this.app.android?.request ?? false)) {
                const update = await this.$store.dispatch(
                    'detail/requestUpdate',
                    this.app,
                )

                if (update == null) {
                    alert(
                        'Erro ao requisitar update de app. Por favor, tente novamente ou entre em contato com um de nossos desenvolvedores',
                    )
                    return
                }
                this.app = update
            }
        }

        this.$store.commit('home/updateAppAtHomeModule', this.app)
        this.onClose()
    }
}
